import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { styles } from "./skeleton-rect.css";

/**
 * A skeleton loading rectangle with shimmer animation
 */
@customElement("skeleton-rect")
export class SkeletonRect extends LitElement {
  static override styles = styles;

  /**
   * Width of the skeleton rectangle. Can be any valid CSS size value.
   * @default "100%"
   */
  @property({ type: String })
  width = "100%";

  /**
   * Height of the skeleton rectangle. Can be any valid CSS size value.
   * @default "100%"
   */
  @property({ type: String })
  height = "100%";

  /**
   * Elevation level that controls the background color depth.
   * Higher elevation appears "closer" with darker colors.
   * @default 0
   */
  @property({ type: Number })
  elevation: 0 | 1 | 2 = 0;

  protected override updated() {
    // Update CSS custom properties when properties change
    this.style.setProperty("--width", this.width);
    this.style.setProperty("--height", this.height);
    this.style.setProperty("--elevation", this.elevation.toString());
  }

  protected override render() {
    return html`
      <div class="content">
        <slot></slot>
      </div>
      <div class="shimmer" aria-hidden="true"></div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "skeleton-rect": SkeletonRect;
  }
}
